import { FormError, State } from '@/types';

export function createInitState<T>(fields: Array<keyof T>): State<T> {
  const errors = Object.fromEntries(fields.map((field) => [field, undefined])) as FormError<T>;

  return {
    globalError: undefined,
    errors,
    success: false,
  };
}
